import styled, { css } from 'styled-components/macro';

const CHECK_ICON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none'%3E%3Cpath d='M2 6.5L4.5 9L10 3.5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";

export const TreeWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;

    &,
    & * {
      box-sizing: border-box;
    }

    /* ─── Tree node row ──────────────────────────────────── */
    .rc-tree {
      margin: 0;
      padding: 0;
      border: none;
    }

    .rc-tree-list-holder {
      overflow-y: auto !important;
      scrollbar-gutter: stable;
    }

    .rc-tree-treenode {
      display: flex;
      align-items: center;
      width: 100%;
      height: 32px;
      padding: 0 ${theme.spacings.xs};
      cursor: pointer;
      list-style: none;
      outline: none;
      transition: background-color 100ms ease-in-out;

      &:hover {
        background-color: ${theme.semantic.bg.surfaceSubtle};
      }

      &.rc-tree-treenode-disabled {
        cursor: not-allowed;

        .rc-tree-title {
          color: ${theme.semantic.text.disabled};
        }
      }

      &:not(:has(.rc-tree-indent-unit)) .rc-tree-switcher-noop {
        display: none;
      }
    }

    .rc-tree-list-scrollbar {
      display: none;
    }

    /* ─── Indent ─────────────────────────────────────────── */

    .rc-tree-indent {
      display: inline-flex;
      align-self: stretch;
      user-select: none;
    }

    .rc-tree-indent-unit {
      display: inline-block;
      width: 20px;
    }

    /* ─── Switcher ───────────────────────────────────────── */

    .rc-tree-switcher {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      flex-shrink: 0;

      &.rc-tree-switcher_open::before {
        transform: rotate(90deg);
      }

      &.rc-tree-switcher-noop {
        visibility: hidden;
        pointer-events: none;
      }
    }

    /* ─── Checkbox ───────────────────────────────────────── */

    .rc-tree-checkbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      margin: 0 8px 0 4px;
      border: 1.5px solid ${theme.semantic.border.control};
      border-radius: 4px;
      background-color: ${theme.semantic.control.bg};
      background-image: none !important;
      box-sizing: border-box;
      transition:
        border-color 150ms ease-in-out,
        background-color 150ms ease-in-out;

      /* icon/accent, а не control/bg-checked: в дизайн-системе эта роль
         описана как «галочка меню и отмеченный чекбокс в дереве», её scopes
         разрешают заливку. У обычного чекбокса другая роль и другой оттенок. */
      &.rc-tree-checkbox-checked {
        background-color: ${theme.semantic.icon.accent};
        border-color: ${theme.semantic.icon.accent};

        &::after {
          content: '';
          display: block;
          width: 12px;
          height: 12px;
          background-image: ${CHECK_ICON};
          background-repeat: no-repeat;
          background-size: 12px 12px;
        }
      }

      &.rc-tree-checkbox-indeterminate {
        background-color: ${theme.semantic.icon.accent};
        border-color: ${theme.semantic.icon.accent};

        &::after {
          content: '';
          display: block;
          width: 8px;
          height: 2px;
          background-color: ${theme.semantic.icon.onControl};
          border-radius: 1px;
        }
      }

      &.rc-tree-checkbox-disabled {
        opacity: 0.55;
        cursor: not-allowed;
      }
    }

    /* ─── Node content ───────────────────────────────────── */

    .rc-tree-node-content-wrapper {
      display: inline-flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      height: 100%;
      gap: ${theme.spacings.xs};
      cursor: pointer;
      background-color: transparent !important;
      overflow: hidden;
    }

    .rc-tree-iconEle {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      background-image: none !important;

      &:empty {
        display: none;
      }
    }

    .rc-tree-title {
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: ${theme.semantic.text.default};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `}
`;
